import {
  NotificationsFilters,
  NotificationsTable,
  NotificationsTableProps,
} from './_components';

import { Stack } from '@cast/design-system';

export const NotificationsList = (props: NotificationsTableProps) => {
  return (
    <Stack data-hc="success" height="100%">
      <NotificationsFilters />
      <NotificationsTable {...props} />
    </Stack>
  );
};
